import {Component, OnInit} from '@angular/core';
import {Router, NavigationEnd, ActivatedRoute} from "@angular/router";
import {filter} from "rxjs/operators";
import {combineLatest, firstValueFrom} from 'rxjs';
import {GetPosPermissionCode} from 'app/helpers/permission-codes';
import {PermissionService} from 'app/services/permission.service';

@Component({
  selector: 'app-menu-edit',
  templateUrl: './menu-edit.component.html',
  styleUrls: ['./menu-edit.component.scss']
})
export class MenuEditComponent implements OnInit {
  selectedIndex = 0;

  public canViewProducts$ = this.permissions.hasPermission$(GetPosPermissionCode.GetPosProductView);
  public canViewPromo$ = this.permissions.hasPermission$(GetPosPermissionCode.GetPosPromoView);
  public canViewMenu$ = this.permissions.hasPermission$(GetPosPermissionCode.GetPosMenuView);

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private permissions: PermissionService
  ) {
    // Sync selected tab with current route
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateSelectedIndex();
    });

    // Initialize on load
    this.updateSelectedIndex();
  }

  async ngOnInit(): Promise<void> {
    // Авто-переход на первый доступный подраздел — только если дочерний роут ещё не активен.
    // Полагаться на this.router.url здесь нельзя: в ngOnInit во время навигации он содержит
    // ПРЕДЫДУЩИЙ URL (Angular обновляет URL после активации, urlUpdateStrategy='deferred').
    if (this.route.snapshot.firstChild) {
      return;
    }

    const [canViewProducts, canViewPromo, canViewMenu] = await firstValueFrom(combineLatest([
      this.canViewProducts$,
      this.canViewPromo$,
      this.canViewMenu$,
    ]));
    const firstAvailableRoute = canViewProducts
      ? 'modifier-group'
      : canViewPromo
        ? 'promo'
        : canViewMenu
          ? 'rp-programs'
          : null;
    if (firstAvailableRoute) {
      // Абсолютный путь из сегментов текущего роута: relativeTo-навигация от пустого пути
      // при relativeLinkResolution:'legacy' резолвится ненадёжно, а router.url в ngOnInit ещё
      // хранит предыдущий URL. pathFromRoot даёт /app/{org}/menu-edit.
      const base = '/' + this.route.pathFromRoot
        .flatMap(r => r.snapshot.url.map(segment => segment.path))
        .filter(Boolean)
        .join('/');
      await this.router.navigateByUrl(`${base}/${firstAvailableRoute}`);
    }
  }

  private updateSelectedIndex(): void {
    const currentUrl = this.router.url;
    if (currentUrl.includes('/promo')) {
      this.selectedIndex = 1;
    } else if (currentUrl.includes('/allergen-groups')) {
      this.selectedIndex = 2;
    } else if (currentUrl.includes('/default-images')) {
      this.selectedIndex = 3;
    } else if (currentUrl.includes('/rp-programs')) {
      this.selectedIndex = 4;
    } else {
      // Default to modifier-group (including empty path and modifier-group)
      this.selectedIndex = 0;
    }
  }
}
